import request from '@/utils/request'

const getInvite = (page, limit) => {
  return request({
    url: '/api/invite',
    method: 'post',
    data: {
      page: page,
      limit: limit
    }
  })
}

const receivedInviteBonus = () => {
  return request({
    url: '/api/invite/bonus',
    method: 'get'
  })
}

const getInviteBanner = () => {
  return request({
    url: '/api/invite/banners',
    method: 'get'
  })
}

export default {
  getInvite,
  receivedInviteBonus,
  getInviteBanner
}
